// WalletInfoContext.tsx
import { useWalletInfo } from '@/hooks';
import { createContext, useContext, ReactNode, useMemo } from 'react';

const WalletInfoContext = createContext<ReturnType<typeof useWalletInfo> | null>(null);

export const WalletInfoProvider = ({ children }: { children: ReactNode }) => {
  const walletInfo = useWalletInfo();
  
  return (
    <WalletInfoContext.Provider value={walletInfo}>
      {children}
    </WalletInfoContext.Provider>
  );
};

export const useWalletInfoContext = () => {
  const context = useContext(WalletInfoContext);
  if (!context) {
    throw new Error('useWalletInfoContext must be used within WalletInfoProvider');
  }
  return context;
};